import { useEffect, useState } from "react";
import GenericModal from "../../Modal/GenericModal";
import { urlEnum } from "../../Utils/urlEnum";
import { Button } from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";

type PreviewImageProps = {
  title: string | undefined;
  open: boolean;
  onClose: () => void;
  url: string | undefined;
  isVehicleIcon?: boolean;
  changeImage?: () => void;
};
export default function PreviewImage(props: PreviewImageProps) {
  const { title, open, onClose, url, isVehicleIcon, changeImage } = props;
  const [path, setPath] = useState<string | undefined | null>(null);

  useEffect(() => {
    const newPath = url?.replace(`${urlEnum.vehicles}`, "/api");
    if (!newPath) {
      setPath(null);
      return;
    }

    // The image route sits behind auth:api, and a plain <img src> request
    // can't carry the Bearer token the way axios does - it would 401. Fetch
    // it with the token instead and render the resulting blob.
    let cancelled = false;
    let objectUrl: string | null = null;
    const token = localStorage.getItem("access_token");
    fetch(newPath, { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => response.blob())
      .then((blob) => {
        // url may have changed again before this resolved - discard a late
        // response instead of clobbering whatever the newer effect set.
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setPath(objectUrl);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  return (
    <GenericModal
      open={open}
      onClose={onClose}
      title={title || ""}
      maxWidth={1000}
      fullScreenOnMobile={false}
      buttons={
        isVehicleIcon && (
          <Button
            variant="contained"
            color="primary"
            style={{ color: "white" }}
            startIcon={<AddPhotoAlternateIcon />}
            onClick={changeImage}
          >
            {Vocabulary?.changeVehicleIcon}
          </Button>
        )
      }
    >
      <div style={{ textAlign: "center" }}>
        {path && <img style={{ width: "80%" }} src={path} alt="No file" />}
      </div>
    </GenericModal>
  );
}
